import React, { FC, useRef } from 'react'
import { ModuleNames } from '../../../../constants/componentNames.constants'
import { AgendaContainer, FAQContainer } from '../style'

//* components
import GlobalContainer from '../../globalContainer'
import Typography from '../../typography'
import { Agenda } from './agenda'
import { FAQ } from './faq'

type Props = {
  content: any
  isAgenda: boolean
  isRichText: boolean
}

export const RenderRowContainers: FC<Props> = ({ content, isAgenda, isRichText }) => {
  const tabs = useRef<HTMLUListElement>()
  const isAccordion = content.useCase === 'Accordion'

  const toggleDrawer = (idx: number) => {
    if (tabs?.current?.children[idx].classList.contains('FAQ-Item__Active')) {
      tabs?.current?.children[idx].classList.remove('FAQ-Item__Active')
    } else {
      tabs?.current?.children[idx].classList.add('FAQ-Item__Active')
    }
  }

  if (content.rows.length >= 1) {
    const inner = content.rows.map((module: any, i: number) => {
      switch (module.__typename) {
        case ModuleNames.TOPIC_FAQ:
          return (
            <FAQ
              data={module}
              idx={i}
              key={`content-rows-inner--${module.__typename}-${i}`}
              toggleDrawer={toggleDrawer}
            />
          )
        case ModuleNames.TOPIC_AGENDA:
          return <Agenda data={module} key={`content-rows-inner--${module.__typename}-${i}`} />
        default:
          return null
      }
    })

    if (isAgenda) {
      const agendaInner = (
        <AgendaContainer>
          {content.title && <Typography type="labelAlt">{content.title}</Typography>}
          {inner}
        </AgendaContainer>
      )

      if (!isRichText) {
        return (
          <GlobalContainer>
            <AgendaContainer>
              {content.title && <Typography type="labelAlt">{content.title}</Typography>}
              {inner}
            </AgendaContainer>
          </GlobalContainer>
        )
      } else {
        return agendaInner
      }
    } else if (isAccordion) {
      return (
        <GlobalContainer>
          <FAQContainer>
            {content.title && <Typography type="labelAlt">{content.title}</Typography>}
            <ul className="ContentRows__FAQ-Container" ref={(tab: any) => (tabs.current = tab)}>
              {inner}
            </ul>
          </FAQContainer>
        </GlobalContainer>
      )
    } else {
      return null
    }
  } else {
    return null
  }
}
